/* eslint-disable max-lines */
import './webpack-imports';
import './polyfills';
import './gsap';
import fetchJsonp from 'fetch-jsonp';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import calculateScrollbarWidth from '../modules/calculate-scrollbar-width';
import slider from './inits/slider';
import innerSlider from './inits/inner-slider';
import thumbsSliders from './inits/thumbs-slider';
import isIE from './utils/is-ie';
import './inits/scroll';
import './inits/lazy-load';
import './inits/stories';
import './inits/popups';
import './inits/metrics';

document.documentElement.classList.add('js-ready');

const priceDelimiter = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
let windowHeight = window.innerHeight;

window.addEventListener('resize', () => {
    windowHeight = window.innerHeight;
});

if (isIE()) {
    document.documentElement.classList.add('ie');
    document.addEventListener('mousewheel', (event) => {
        event.preventDefault();
        window.scrollTo(0, window.pageYOffset - event.wheelDelta);
    });
}

/**
 * Получаем цены на стайлеры
 */
[
    {
        mpn: 'S5MB.ALMPCOM',
        shopName: 'Technopark',
    },
    {
        mpn: 'S5BB.ALBPCOM',
        shopName: 'Mvideo',
        // shopName: 'rushop.lg.com',
    },
    {
        mpn: 'S3WER.ALWPCOM',
        shopName: 'rushop.lg.com',
    },
    {
        mpn: 'S3MFC.ALMPCOM',
        shopName: 'rushop.lg.com',
    },
].forEach((data) => {
    const { mpn, shopName } = data;
    fetchJsonp(`https://gethatch.com/5aeaeae846e0fb0001be20f4/affiliate/52751/json?region=ru&mpn=${mpn}`)
        .then((res) => res.json())
        .then((response) => {
            const stylerPriceElements = Array.from(document.querySelectorAll(`.js-styler-price[data-mpn="${mpn}"]`));
            const stylerBuyLinks = Array.from(document.querySelectorAll(`.js-styler-buy-link[data-mpn="${mpn}"]`));
            const stylerOutOfStockEls = Array.from(
                document.querySelectorAll(`.js-styler-out-of-stock[data-mpn="${mpn}"]`),
            );

            if (response.iceleads_interface.retailers?.retailer?.length > 0) {
                const exactShopData = response.iceleads_interface.retailers.retailer.find(
                    (obj) => obj.name === shopName,
                );
                if (exactShopData) {
                    stylerPriceElements.forEach((el) => {
                        el.textContent = `${priceDelimiter(exactShopData.price)} ₽`;
                    });

                    if (exactShopData.stock_qty === 0) {
                        stylerBuyLinks.forEach((el) => {
                            el.hidden = true;
                        });
                        stylerOutOfStockEls.forEach((el) => {
                            el.hidden = false;
                        });
                    }
                } else {
                    stylerBuyLinks.forEach((el) => {
                        el.hidden = true;
                    });
                    stylerOutOfStockEls.forEach((el) => {
                        el.hidden = false;
                    });
                }
            } else {
                stylerBuyLinks.forEach((el) => {
                    el.hidden = true;
                });
                stylerOutOfStockEls.forEach((el) => {
                    el.hidden = false;
                });
            }
        });
});

calculateScrollbarWidth();

slider.init().then(() => {
    setTimeout(() => {
        innerSlider.init();
        thumbsSliders.init();
    }, 500);
});

ScrollTrigger.matchMedia({
    '(min-width: 1025px)': () => {
        gsap.to('.js-scroll-down-container', {
            scrollTrigger: {
                trigger: '.js-scroll-down-container',
                start: 'top top',
                end: 'bottom bottom',
                pin: true,
                pinSpacing: false,
            },
        });

        gsap.to('.js-main-section', {
            y: '30vh',
            scrollTrigger: {
                trigger: '.js-section-main',
                start: 'top top',
                end: 'bottom bottom',
                scrub: true,
            },
        });

        gsap.to('.js-section-main', {
            scrollTrigger: {
                trigger: '.js-section-main',
                start: 'bottom bottom',
                end: 'bottom top',
                pin: true,
                pinSpacing: false,
                anticipatePin: 1,
            },
        });
    },
});

const girlsTl = gsap.timeline({
    scrollTrigger: {
        trigger: '.js-section-main',
        start: 'top top',
        end: 'bottom bottom',
        scrub: true,
    },
});

ScrollTrigger.matchMedia({
    '(min-width: 1025px)': () => {
        girlsTl
            .from('.js-main-bg-girls', {
                opacity: 0,
                yPercent: 50,
            })
            .from('.js-main-bg-girl-reflection', {
                opacity: 0.2,
            });
    },
    '(max-width: 375px)': () => {
        girlsTl
            .from('.js-main-bg-girls', {
                opacity: 0,
                y: 30,
            })
            .from('.js-main-bg-girl-reflection', {
                opacity: 0.2,
            });
    },
    '(min-width: 376px) and (max-width: 1024px)': () => {
        girlsTl
            .from('.js-main-bg-girls', {
                opacity: 0,
                // yPercent: 20,
                y: 40,
            })
            .from('.js-main-bg-girl-reflection', {
                opacity: 0.2,
            });
    },
});

const sections = Array.from(document.querySelectorAll('.js-interior'));

gsap.to('.js-interior-section-before__text', {
    opacity: 0.1,
    scrollTrigger: {
        trigger: '.js-interior-section-before',
        start: 'top top',
        end: 'bottom center',
        scrub: true,
        pin: true,
        anticipatePin: 1,
        pinSpacing: false,
    },
});

gsap.to('.js-interiors', {
    scrollTrigger: {
        trigger: '.js-interiors',
        start: `top top`,
        // end: () => `+=${windowHeight * 5}`,
        pin: true,
        pinSpacing: false,
        anticipatePin: 1,
    },
});

gsap.to('.js-interiors', {
    opacity: 1,
    scrollTrigger: {
        trigger: '.js-interiors',
        start: `top top`,
        end: () => `+=${windowHeight * 0.3}`,
        scrub: true,
    },
});

const firstText = document.querySelector('.js-interior__text-container--1');
const secondText = document.querySelector('.js-interior__text-container--2');

const maskTl = gsap.timeline({
    defaults: { ease: 'power2.in', duration: 0.5 },
    scrollTrigger: {
        trigger: '.js-interior-texts',
        start: `top+=${windowHeight * 2} top`,
        end: () => '+=1',
        toggleActions: 'play none reverse none',
        invalidateOnRefresh: true,
    },
});

gsap.set(secondText, { opacity: 0 });

if (!isIE()) {
    maskTl
        .to('.interior-last', { '--mask-outer': 100 })
        .to('.interior-last', { '--mask-inner': 100 }, 0.15)
        .to(firstText, { opacity: 0 }, 0)
        .to(secondText, { opacity: 1 }, 0);
} else {
    gsap.set(sections[1], { opacity: 0 });
    maskTl
        .to(sections[0], { opacity: 0 })
        .to(sections[1], { opacity: 1 }, 0)
        .to(firstText, { opacity: 0 }, 0)
        .to(secondText, { opacity: 1 }, 0);
}

const firstSectionTextTl = gsap.timeline({
    scrollTrigger: {
        trigger: firstText,
        start: `top top`,
        end: () => `+=${windowHeight * 4}`,
        pin: true,
        pinSpacing: false,
        anticipatePin: 1,
        scrub: true,
    },
});

firstSectionTextTl.to('.js-interior__text--1', { y: -200 });

const secondSectionTextTl = gsap.timeline({
    scrollTrigger: {
        trigger: secondText,
        start: `top top`,
        end: () => `+=${windowHeight * 4}`,
        pin: true,
        anticipatePin: 1,
        scrub: true,
        pinSpacing: false,
    },
});

gsap.fromTo(
    '.js-interior__text--2',
    {
        y: 300,
    },
    {
        y: 0,
        scrollTrigger: {
            trigger: secondText,
            start: `top+=${0}px top`,
            end: () => `+=${windowHeight * 4}`,
            scrub: true,
        },
    },
);

ScrollTrigger.matchMedia({
    '(min-width: 1025px)': () => {
        gsap.to('.js-styler-improved', {
            scrollTrigger: {
                trigger: '.js-styler-improved',
                endTrigger: '.js-interior-section-before',
                start: () => 'center-=4.9% center',
                end: () => `+=${windowHeight * 6}`,
                scrub: true,
                pin: true,
                anticipatePin: 1,
                pinSpacing: false,
            },
        });
    },
    '(max-width: 1024px)': () => {
        gsap.to('.js-styler-improved', {
            scrollTrigger: {
                trigger: '.js-styler-improved',
                endTrigger: '.js-interior-section-before',
                start: () => 'top-=14% top',
                end: () => `+=${windowHeight * 6}`,
                scrub: true,
                pin: true,
                anticipatePin: 1,
                pinSpacing: false,
            },
        });
    },
});

const lightsTl = gsap.timeline({
    scrollTrigger: {
        trigger: sections[0],
        start: `top top`,
        end: () => `+=${windowHeight}`,
        scrub: true,
    },
});

lightsTl
    .to('.js-styler-improved-light-top', { opacity: 0 })
    .to('.js-styler-improved-light-1', { opacity: isIE() ? 0.5 : 1 });

// const ballsSections = Array.from(document.querySelectorAll('.js-balls-section'));
// ballsSections.forEach((section) => {
//     const styler = section.querySelector('.js-balls-section-styler');
//     const text = section.querySelector('.js-balls-section-text');
//     const balls = Array.from(section.querySelectorAll('.js-balls-section__ball'));

//     gsap.to(section, {
//         scrollTrigger: {
//             trigger: section,
//             start: 'top top',
//             pin: true,
//             anticipatePin: 1,
//             pinSpacing: false,
//         },
//     });

//     gsap.fromTo(
//         balls,
//         {
//             scale: 0,
//         },
//         {
//             scale: 1.5,
//             scrollTrigger: {
//                 trigger: section,
//                 start: 'top bottom',
//                 scrub: true,
//                 end: 'bottom top',
//             },
//         },
//     );

//     ScrollTrigger.matchMedia({
//         '(min-width: 1025px)': () => {
//             gsap.from(text, {
//                 y: 450,
//                 scrollTrigger: {
//                     trigger: section,
//                     start: 'top bottom',
//                     scrub: true,
//                 },
//             });

//             gsap.from(text, {
//                 opacity: 0,
//                 duration: 0.5,
//                 scrollTrigger: {
//                     trigger: text,
//                     start: 'top bottom',
//                 },
//             });

//             gsap.to(styler, {
//                 scale: 0.9,
//                 scrollTrigger: {
//                     trigger: section,
//                     start: 'top bottom',
//                     scrub: true,
//                 },
//             });
//         },
//     });
// });

Array.from(document.querySelectorAll('.js-advantage')).forEach((el, i) => {
    const imgWrapper = el.querySelector('.js-advantage__img-container');
    const img = el.querySelector('.js-advantage__img');
    const content = el.querySelector('.js-advantage__content');

    ScrollTrigger.matchMedia({
        '(min-width: 1025px)': () => {
            gsap.to(img, {
                yPercent: -30,
                scrollTrigger: {
                    trigger: imgWrapper,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                },
            });

            gsap.to(content, {
                y: 200 * (i % 2 === 0 ? 1 : -1),
                scrollTrigger: {
                    trigger: content,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                },
            });

            gsap.from(content, {
                opacity: 0,
                duration: 0.5,
                scrollTrigger: {
                    trigger: content,
                    start: 'center bottom',
                    end: 'bottom top',
                },
            });
        },
        '(max-width: 1024px)': () => {
            gsap.to(img, {
                yPercent: -20,
                scrollTrigger: {
                    trigger: img,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                },
            });
        },
    });
});

gsap.to('.js-section-main', {
    duration: 0.5,
    delay: 1,
    opacity: 1,
});

// gsap.to('.js-cta', {
//     scrollTrigger: {
//         pin: true,
//         anticipatePin: 1,
//         pinReparent: true,
//         pinSpacing: false,
//         trigger: '.js-cta',
//         start: 'top top',
//         endTrigger: 'html',
//         end: 'bottom top',
//     },
// });

module.hot?.accept();
